var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 9.375H4.6875C3.82456 9.375 3.125 10.0746 3.125 10.9375V43.75C3.125 44.6129 3.82456 45.3125 4.6875 45.3125H7.8125C8.67545 45.3125 9.375 44.6129 9.375 43.75V10.9375C9.375 10.0746 8.67545 9.375 7.8125 9.375Z",
    stroke: "#593122",
    strokeWidth: 3.125,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 21.875H23.4375M10.9375 39.0625H23.4375",
    stroke: "#593122",
    strokeWidth: 3.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 15.625H12.5C11.6371 15.625 10.9375 16.3246 10.9375 17.1875V43.75C10.9375 44.6129 11.6371 45.3125 12.5 45.3125H21.875C22.7379 45.3125 23.4375 44.6129 23.4375 43.75V17.1875C23.4375 16.3246 22.7379 15.625 21.875 15.625Z",
    stroke: "#593122",
    strokeWidth: 3.125,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8125 4.6875H26.5625C25.6996 4.6875 25 5.38706 25 6.25V43.75C25 44.6129 25.6996 45.3125 26.5625 45.3125H32.8125C33.6754 45.3125 34.375 44.6129 34.375 43.75V6.25C34.375 5.38706 33.6754 4.6875 32.8125 4.6875Z",
    stroke: "#593122",
    strokeWidth: 3.125,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2559 9.38572L37.3106 9.80076C36.2246 9.91502 35.4375 10.9306 35.5596 12.0566L38.9698 43.4619C39.0928 44.5879 40.0801 45.415 41.166 45.3017L45.1114 44.8867C46.1973 44.7724 46.9844 43.7568 46.8623 42.6308L43.4571 11.2304C43.3291 10.0996 42.3418 9.27146 41.2559 9.38572Z",
    stroke: "#593122",
    strokeWidth: 3.125,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.25563ce05e5ef864102ee81a211f333b.svg";
export { ForwardRef as ReactComponent };